import $ from 'jquery'

export default class cannabisSchengenAddToCartFlipHDSearch {
    constructor (element) {
        console.log(element)
        this.$element = $(element)
        this.$openHDSearchButton = this.$element.find('#openHDSearchButton')

        this.$formScreen = this.$element.find('#formScreen')
        this.$hdSearchScreen = this.$element.find('#hdSearchScreen')
        this.$backToFormScreen = this.$element.find('#backToFormScreen')

        this.$openHDSearchButton.on('click', this.handleClickGoToHDSearch.bind(this))
        this.$backToFormScreen.on('click', this.handleClickGoToForm.bind(this))
        this.$hdSearchScreen.on('change', 'input[name=healthDepartmentSelect]', this.selectHD.bind(this))
    }

    selectHD () {
        const selected = this.$hdSearchScreen.find('input[name=healthDepartmentSelect]').value()
        this.$formScreen.find('input[name=healthDepartment]').val(selected)
    }

    handleClickGoToHDSearch (event) {
        event.preventDefault()
        this.$hdSearchScreen.show()
        this.$formScreen.hide()
    }

    handleClickGoToForm (event) {
        event.preventDefault()
        this.$hdSearchScreen.hide()
        this.$formScreen.show()
    }
}
